import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  hasSelectedYearsFilterSelector,
  searchYearTypesState,
  selectedYearsFilterLabelSelector,
  selectedYearsFilterSelector,
  yearsFilterDefaultState,
  yearsFilterState,
} from '@/states/filters/years.state';

export function useYearsFilterHook() {
  const [yearsFilterDefault, setYearsFilterDefault] = useRecoilState(
    yearsFilterDefaultState
  );
  const [searchYearTypeFilter, setSearchYearTypeFilter] =
    useRecoilState(searchYearTypesState);
  const [yearsFilter, setYearsFilter] = useRecoilState(yearsFilterState);
  const setSelectedYearsFilter = useSetRecoilState(selectedYearsFilterSelector);
  const selectedYearsFilterLabel = useRecoilValue(
    selectedYearsFilterLabelSelector
  );
  const hasSelectedYearsFilter = useRecoilValue(hasSelectedYearsFilterSelector);
  const resetYearsFilter = () => {
    const defaultRange = { min: 0, max: 0 };

    setSelectedYearsFilter(defaultRange);
    setYearsFilter(defaultRange);
  };

  return {
    yearsFilterDefault,
    setYearsFilterDefault,
    yearsFilter,
    setYearsFilter,
    setSelectedYearsFilter,
    selectedYearsFilterLabel,
    hasSelectedYearsFilter,
    resetYearsFilter,
    searchYearTypeFilter,
    setSearchYearTypeFilter,
  };
}
